import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {

  dialogTitle: string;
  dialogMessage: string;
  showOkButton: boolean;
  showCancelButton: boolean;
  showSubmitButton: boolean;
  showConfirmButton: boolean;
  showFinishButton: boolean;
  showButtons: boolean;
  showLoading:boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.dialogTitle = data.title;
    this.dialogMessage = data.message;
    this.showOkButton = data.showOkButton ?? true; // Default to true if not provided
    this.showButtons = data.showButtons ?? true; // Default to true if not provided
    this.showCancelButton = data.showCancelButton ?? false; // Default to false if not provided
    this.showSubmitButton = data.showSubmitButton ?? false; // Default to false if not provided
    this.showConfirmButton = data.showConfirmButton ?? false;
    this.showFinishButton = data.showFinishButton ?? false;
    this.showLoading = data.showLoading ?? false;
  }

  onOkClick(): void {
    this.dialogRef.close('ok');
  }

  onCancelClick(): void {
    this.dialogRef.close('cancel');
  }

  onSubmitClick(): void {
    this.dialogRef.close('submit');
  }
  onConfirmClick(): void {
    this.dialogRef.close('confirm');
  }
  onFinishClick(): void {
    this.dialogRef.close('finish');
  }
}

export interface DialogData {
  title: string;
  message: string;
  showButtons?: boolean;
  showOkButton?: boolean;
  showCancelButton?: boolean;
  showSubmitButton?: boolean;
  showConfirmButton?: boolean;
  showFinishButton?: boolean;
  showLoading?:boolean;
}
